import React from "react";
import { withRouter } from "react-router-dom";

class ResponsiveMap extends React.Component {
  handleDownload = () => {
    window.location.href = "/api/download-map";
  };

  handleClose = () => {
    this.props.history.push("/");
  };

  render() {
    return (
      <div className="responsive-map-page light-mode responsive-page">
        <div className="content">
          <button
            onClick={this.handleDownload}
            className="download-button"
            aria-label="Download Map"
          />
          <button
            onClick={this.handleClose}
            className="close-button"
            aria-label="Close"
          />
        </div>
      </div>
    );
  }
}

export default withRouter(ResponsiveMap);
